// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1vuUV"};